import React from "react";
import { Card, Col } from "antd";
import { NavLink } from "react-router-dom";

function DashboardCard({ bgColor, icon, to, text, today = 0, total, isNotToday }) {
  return (
    <div>
      <div>
        <NavLink to={to}>
          <Card
            title=""
            bordered={true}
            className={`transition-all hover:scale-105 duration-300 dark:text-gray-200 ${bgColor} request-card rounded-3xl`}
          >
            <div className="h-20 flex flex-col justify-between">
              <div className="flex justify-between items-center">
                <div>
                  <h1 className="text-[18px] font-bold">{total}</h1>
                  <p className="text-[12px] font-medium opacity-90">{text}</p>
                </div>
                <img src={icon} alt="" className="w-12 h-12" />
              </div>
              {!isNotToday && (
                <p className="text-[10px] font-bold">
                  + {today} Unread
                </p>
              )}
            </div>
          </Card>
        </NavLink>
      </div>
    </div>
  );
}

export default DashboardCard;
